
import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "@/components/Header";
import NavBar from "@/components/NavBar";
import ScoringPanel from "@/components/ScoringPanel";
import { Course, User, BirdieGameGroup } from "@/types";

interface ScoringContainerProps {
  golfers: User[];
  course: Course;
  eligibleGames: BirdieGameGroup[];
  gameId?: string;
}

const ScoringContainer = ({ 
  golfers, 
  course, 
  eligibleGames,
  gameId 
}: ScoringContainerProps) => {
  const navigate = useNavigate();
  
  const handleReset = () => {
    navigate("/");
  };

  return (
    <div className="min-h-screen pb-16">
      <Header 
        title="Score Group" 
        course={course} 
      />
      <ScoringPanel 
        golfers={golfers}
        course={course}
        eligibleGames={eligibleGames}
        onReset={handleReset}
        gameId={gameId}
      />
      <NavBar />
    </div>
  );
};

export default ScoringContainer;
